import { render, staticRenderFns } from "./Coparate.vue?vue&type=template&id=1645e520"
import script from "./Coparate.vue?vue&type=script&lang=js"
export * from "./Coparate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports